<template>
    <div class="ma-4">
        <StaffNav class="hideOnPrint" />
        <v-row class="hideOnPrint">
            <v-col cols="12">
            <v-card>
                <v-card-title style="background-color: #2b3990">
                    <span class="headline white--text">{{ titleForm }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-select
                                    v-model="items.TypeOfHealthCare"
                                    label="Type of Health Care"
                                    :items="types"
                                >
                                    <template v-slot:item="{ item }">
                                        <span class="me-2">{{ item }}</span>
                                        <v-chip
                                            color="yellow yellow-darken-3"
                                            text-color="black"
                                            small
                                            light
                                        >
                                            sample
                                        </v-chip>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-menu
                                    ref="menu1"
                                    v-model="menu1"
                                    :close-on-content-click="true"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="items.Date"
                                        label="Date"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="items.Date"
                                    no-title
                                    scrollable
                                >
                                </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" class="pa-2">
                                <v-text-field
                                    v-model="items.Amount"
                                    label="Amount"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
    
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="#259647"
                        class="white--text"
                        @click="onAddItem"
                        v-if="$route.params.action === 'add' && !isAuditorRole"
                    >
                        Save
                    </v-btn>
                    <!-- <v-btn
                        fab
                        small
                        @click="onPrintItem"
                        class="mr-8 mb-2 white--text"
                        color="#2b6993"
                        elevation="4"
                        v-if="$route.query.new"
                    >
                        <v-icon>print</v-icon>
                    </v-btn> -->
                    <v-btn
                        class="primary"
                        @click="onUpdateItem"
                        v-if="$route.query.new && !isAuditorRole"
                    >
                        Update
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                </v-card-actions>
            </v-card>
            </v-col>
        </v-row>
        <Foot class="hideOnPrint" />
    
        <!-- <PrintItem
            :items="items"
            :staffName="staffName"
            :isPrintingItem="isPrintingItem"
        /> -->
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from "vuex";
  import StaffNav from "@/components/StaffNav";
  import Foot from "@/components/Footer";
//   import LoadPdf from "@/components/LoadPDF.vue";
  import renameFileHelper from "@/mixins/renameFileHelper";
//   import PrintItem from "./print/PrintItem";
//   import PrintUtil from "../../../../utils/print-util";
  
    const url = require("@/client_config/config").url;
    
    export default {
        mixins: [renameFileHelper],
        components: {
            StaffNav,
            Foot,
            // LoadPdf,
            // PrintItem,
        },
        data() {
            return {
                employeeID: this.$route.params.employeeID,
                itemId: "",
                date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
                menu1: false,
                titleForm: "New Health Care",
                items: {
                    document: [],
                    status: "Active",
                },
                types: ["Health Care 1", "Health Care 2", "Health Care 3"],
                isPrintingItem: false,
                token: localStorage.getItem('token'),
            };
        },
        computed: {
            ...mapState("healthcare", ["isLoading", "uploadFileItems", "item"]),
            staffName() {
                return this.$store.state.users.user.Name;
            },
            isAuditorRole() {
                return localStorage.getItem("userRole") === 'Auditor'
            },
            generateDownloadUrl() {      
                return `${url}/healthcare/generate/report/${this.$route.query.id}`;
            }
        },
    
        created() {
            if (this.$route.query.new) {
                this.fetch();
            }
        },
    
        methods: {
            ...mapActions("healthcare", [
                "getItem",
                "addItem",
                "updateItem",
                "uploadItem",
            ]),
        
            async fetch() {
                await this.getItem(this.$route.query.id);
                this.viewItem(this.item);
            },
        
            viewItem(item) {
                this.titleForm = "Viewing Health Care";
                this.items.TypeOfHealthCare = item.TypeOfHealthCare;
                this.items.Date = item.Date;
                this.items.Amount = item.Amount;
                this.itemId = item._id;
        
                // if (item.documents.length > 0) {
                //     const tempData = [];
                //     for (let i = 0; i < item.documents.length; i++) {
                //         let fileExt = item.documents[i].AWSLink.split(".").pop();
                //         tempData.push({
                //         name: item.documents[i].Name,
                //         id: item.documents[i]._id,
                //         aws: item.documents[i].AWSLink,
                //         ext: fileExt,
                //         });
                //     }
                //     this.items.document = tempData;
                // }
                // this.itemId = item._id;
            },
        
            async onUpdateItem() {
                try {
                    const d = new Date(Date.now());
                    const newDate = new Date(this.items.Date);

                    newDate.setHours(d.getHours())
                    newDate.setMinutes(d.getMinutes())
                    newDate.setSeconds(d.getSeconds())
                    newDate.setMilliseconds(d.getMilliseconds())

                    const data = {
                        TypeOfHealthCare: this.items.TypeOfHealthCare,
                        Date: newDate.toISOString(),
                        Amount: this.items.Amount,
                    };
            
                    const result = await this.updateItem({
                        id: this.itemId,
                        data,
                    });
            
                    if (result.status === 200) {
                        this.$router.push({
                            path: `/healthcare/${this.$route.params.employeeID}`,
                        });
                        // this.saveFile();
                    }
                } catch (error) {
                    this.errorMsg("updating", "record", error);
                }
            },
        
            async onAddItem() {
                try {
                    const d = new Date(Date.now());
                    const newDate = new Date(this.items.Date);

                    newDate.setHours(d.getHours())
                    newDate.setMinutes(d.getMinutes())
                    newDate.setSeconds(d.getSeconds())
                    newDate.setMilliseconds(d.getMilliseconds())

                    const data = {
                        TypeOfHealthCare: this.items.TypeOfHealthCare,
                        Date: newDate.toISOString(),
                        Amount: this.items.Amount,
                        User: this.employeeID,
                    };
            
                    const response = await this.addItem(data);
            
                    if (response.status === 201) {
                        this.$router.push({
                            path: `/healthcare/${this.$route.params.employeeID}`,
                        });
            
                        this.itemId = response.data.results._id;
                        // this.saveFile();
                    }
                } catch (error) {
                    this.errorMsg("adding", "record", error);
                }
            },
        
            async fileSelected(e) {
                try {
                    const files = await this.renameFileHelper(
                        e,
                        this.staffName,
                        "Garnishment",
                        this.items.courtDate
                    );
                    files.forEach((file) => this.addUploadFile(file));
                } catch (error) {
                    this.errorMsg("adding", "file", error);
                }
            },
        
            saveFile() {
                if (this.uploadFileItems.length === 0) return;

                this.uploadFileItems.forEach((file) => {
                    this.uploadItem({
                        file,
                        id: this.itemId,
                        userId: this.$route.params.employeeID,
                    });
                });
            },
        
            addUploadFile(file) {
                this.$store.commit("garnishments/ADD_UPLOAD_FILE", file);
            },
        
            deleteChip(index) {
                this.item.document.splice(index, 1);
            },
        
            close() {
                this.$router.push({
                path: `/healthcare/${this.employeeID}`,
                });
            },
        
            onPrintItem() {
                // PrintUtil.showPrintOption(this.generateDownloadUrl, this.$route.query.id, this.token, 'garnishments');
            },
        
            errorMsg(action, item, error) {
                console.error(`An error occured whiling ${action} ${item}`, error);
            },
        },
    };
  </script>
  